import React, { useState } from "react";
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from "react-router-dom";

const SignInPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const handleSignIn = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !password) {
      setErrorMessage("Email and password are required.");
      return;
    }

    if (!emailRegex.test(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    try {
      await signIn(email, password);
      setErrorMessage("");
      navigate("/");
    } catch (error: any) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        setErrorMessage('Invalid email or password');
      } else if (error.code === 'auth/too-many-requests') {
        setErrorMessage('Too many failed login attempts. Please try again later.');
      } else {
        setErrorMessage('An error occurred during login. Please try again.');
      }
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-zinc-900 to-black text-white">
      <div className="flex flex-col items-center w-full max-w-md">
        {/* Centered logo above form */}
        <div className="mb-8">
          <img 
            src="/img/garagebot-logo-3.png" 
            alt="GarageBot" 
            className="h-32 w-64"
          />
        </div>
        
        <form
          onSubmit={handleSignIn}
          className="bg-zinc-800 p-8 rounded-lg shadow-md w-full max-w-md"
        >
          <h1 className="text-2xl font-bold mb-4">Sign In</h1>

          {errorMessage && (
            <div className="bg-red-500 text-white p-2 rounded mb-4">
              {errorMessage}
            </div>
          )}

          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium mb-1">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 rounded bg-zinc-700 border border-zinc-600 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="password" className="block text-sm font-medium mb-1">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 rounded bg-zinc-700 border border-zinc-600 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>

          <div className="mb-4 text-right">
            <Link to="/forgot-password" className="text-sm text-emerald-500 hover:underline">
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white p-2 rounded font-medium"
          >
            Sign In
          </button>

          <div className="mt-6 text-center">
            <p className="text-sm">
              Don't have an account? 
              <a href="/register" className="text-emerald-500 hover:underline ml-1">
                Sign Up
              </a>
            </p>
          </div>

        </form>
      </div>
    </div>
  );
};

export default SignInPage;